const biologyLabs = {
  COMMON: 'common',
  MICROSCOPY: 'microscopy',
};

export default Object.freeze(biologyLabs);
